export default __webpack_public_path__ + "static/media/service_3.68e9d774.png";